export default __webpack_public_path__ + "static/media/slide_4.3b2ece67.jpg";